import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export const HookSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-cream border-t border-beige/50" ref={ref} data-id="element-71">
      <div className="max-w-4xl mx-auto text-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.8
      }} className="space-y-6 md:space-y-12" data-id="element-73">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif italic text-charcoal leading-relaxed" data-id="element-74">
            "¿Sientes que el ruido de tus preocupaciones no te deja descansar?"
          </h2>

          <p className="text-xl md:text-2xl font-serif italic text-charcoal/80 leading-relaxed" data-id="element-75">
            ¿Has pasado por una crisis de salud o personal y sientes que has
            perdido tu chispa?
          </p>

          <div className="w-16 h-px bg-gold mx-auto" data-id="element-76"></div>

          <p className="text-lg md:text-xl text-charcoal/70 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-77">
            Muchas mujeres viven atrapadas en el "qué pasará mañana", olvidando
            que la paz se construye hoy,{' '}
            <span className="font-medium text-brown" data-id="element-78">nudo a nudo</span>.
          </p>
        </motion.div>
      </div>
    </section>;
};